<mat-nav-list>
  <a mat-list-item
     *ngIf="isAdmin || isSafetyManager || isTerminalManager || isDriver" [routerLink]="'/dashboard/trip-ratings'" routerLinkActive="active">
    <mat-icon mat-list-icon>dashboard</mat-icon>
    <p mat-line>Trip Ratings</p>
  </a>

<!--  <a mat-list-item-->
<!--     *ngIf="isAdmin" [routerLink]="'/dashboard/drives'" routerLinkActive="active">-->
<!--    <mat-icon mat-list-icon>dashboard</mat-icon>-->
<!--    <p mat-line>Drives</p>-->
<!--  </a>-->

   <a mat-list-item
    *ngIf="isAdmin" [routerLink]='["/dashboard/organizations"]' routerLinkActive="active">
     <mat-icon mat-list-icon>business</mat-icon>
    <p mat-line>Organizations</p>
  </a>

  <a mat-list-item
     *ngIf="isOrgManager || isAdmin || isSafetyManager" [routerLink]='["/dashboard/drivers" + orgIdParam]' routerLinkActive="active">
    <mat-icon mat-list-icon>people</mat-icon>
    <p mat-line>Drivers</p>
  </a>

  <a mat-list-item
     *ngIf="isOrgManager || isAdmin || isSafetyManager" [routerLink]='["/dashboard/tractors"]' routerLinkActive="active">
    <mat-icon mat-list-icon>agriculture</mat-icon>
    <p mat-line>Tractors</p>
  </a>

  <a mat-list-item
     *ngIf="isOrgManager || isAdmin || isSafetyManager" [routerLink]='["/dashboard/trailers"]' routerLinkActive="active">
    <mat-icon mat-list-icon>local_shipping</mat-icon>
    <p mat-line>Trailers</p>
  </a>

   <a mat-list-item
    *ngIf="isOrgManager || isAdmin || isSafetyManager" [routerLink]='["/dashboard/terminals" + orgIdParam]' routerLinkActive="active">
     <mat-icon mat-list-icon>location_city</mat-icon>
    <p mat-line>Terminals</p>
  </a>

   <a mat-list-item
    *ngIf="isOrgManager || isAdmin || isSafetyManager" [routerLink]='["/dashboard/geofence" + orgIdParam]' routerLinkActive="active">
     <mat-icon mat-list-icon>place</mat-icon>
    <p mat-line>GeoFences</p>
  </a>

   <a mat-list-item
    *ngIf="isOrgManager || isAdmin" [routerLink]='["/dashboard/map" + orgIdParam]' routerLinkActive="active">
     <mat-icon mat-list-icon>map</mat-icon>
    <p mat-line>Red Spots</p>
  </a>

  <a mat-list-item
     *ngIf="isAdmin" [routerLink]='["/dashboard/manage-users"]' routerLinkActive="active">
    <mat-icon mat-list-icon>manage_accounts</mat-icon>
    <p mat-line>Manage users</p>
  </a>

  <!--a mat-list-item
     *ngIf="isOrgManager" [routerLink]='["/dashboard/organization" + orgIdParam + "/fleet-policy"]' routerLinkActive="active">
    <mat-icon mat-list-icon>assured_workload</mat-icon>
    <p mat-line>Fleet policy</p>
  </a-->

<!--  <a mat-list-item-->
<!--     *ngIf="isOrgManager || isAdmin" [routerLink]='["#"]' routerLinkActive="active">-->
<!--    <mat-icon mat-list-icon>assured_workload</mat-icon>-->
<!--    <p mat-line>Fleet Policy</p>-->
<!--  </a>-->

<!--  <a mat-list-item-->
<!--     *ngIf="isOrgManager || isAdmin" [routerLink]='["#"]' routerLinkActive="active">-->
<!--    <mat-icon mat-list-icon>settings</mat-icon>-->
<!--    <p mat-line>Settings</p>-->
<!--  </a>-->
</mat-nav-list>
